import '../../../../src/assets/stylus/ui/component/_jPagination.scss'
import '../../../../src/assets/stylus/ui/component/_jPaginationside.scss'
import { VIcon } from 'vuetify/components'
import { h } from 'vue'

export default {
  name: 'j-pagination',
  components: {
    VIcon,
  },
  props: {
    sideslide: Boolean,
    showStatus: { type: Boolean, default: true },
    pagination: { type: Object, default: {} },
  },
  data: () => ({
    totalPages: null,
  }),
  computed: {
    styleFirst() {
      if (!this.pagination || !this.pagination.page || this.pagination.page == 1) {
        var data = {
          class: 'disabled',
        }
      } else {
        data = {
          onClick: () => {
            this.$emit('first')
          },
        }
      }
      return data
    },
    stylePrevious() {
      if (!this.pagination || !this.pagination.page || this.pagination.page == 1) {
        var data = {
          class: 'disabled',
        }
      } else {
        data = {
          onClick: () => {
            this.$emit('previous', this.pagination.page - 1)
          },
        }
      }
      return data
    },
    styleNext() {
      if (!this.pagination || !this.pagination.page || this.pagination.page == this.totalPages) {
        var data = {
          class: 'disabled',
        }
      } else {
        data = {
          onClick: () => {
            this.$emit('next', Number(this.pagination.page) + 1)
          },
        }
      }
      return data
    },
    styleLast() {
      if (!this.pagination || !this.pagination.page || this.pagination.page == this.totalPages) {
        var data = {
          class: 'disabled',
        }
      } else {
        data = {
          onClick: () => {
            this.$emit('last', this.totalPages)
          },
        }
      }
      return data
    },
  },
  render() {
    if (this.sideslide) {
      return (
        <div class="j_pagination_side">
          <a class="j_pagination_first" {...this.styleFirst}>
            <v-icon title="first">mdi-page-first</v-icon>
          </a>
          <a class="j_pagination_privious" {...this.stylePrevious}>
            <v-icon title="previous">mdi-chevron-left</v-icon>
          </a>
          { this.genStatus() }
          <a class="j_pagination_next" {...this.styleNext}>
            <v-icon title="next">mdi-chevron-right</v-icon>
          </a>
          <a class="j_pagination_last" {...this.styleLast}>
            <v-icon title="last">mdi-page-last</v-icon>
          </a>
        </div>
      )
    } else {
      return (
        <div class="j_pagination">
          <a class="j_pagination_first" {...this.styleFirst}>
            <v-icon title="first">mdi-page-first</v-icon>
          </a>
          <a class="j_pagination_privious" {...this.stylePrevious}>
            <v-icon title="previous">mdi-chevron-left</v-icon>
          </a>
          {this.genStatus()}
          <a class="j_pagination_next" {...this.styleNext}>
            <v-icon title="next">mdi-chevron-right</v-icon>
          </a>
          <a class="j_pagination_last" {...this.styleLast}>
            <v-icon title="last">mdi-page-last</v-icon>
          </a>
        </div>
      )
    }
  },
  methods: {
    genStatus() {
      if (!this.showStatus || !this.pagination || Object.keys(this.pagination).length === 0)
        return null

      let currentPage = !this.pagination.page ? 0 : this.pagination.page
      if (this.pagination.totalRows <= 0) this.totalPages = 0
      else this.totalPages = Math.ceil(this.pagination.totalRows / this.pagination.rowsPerPage)

      if (this.sideslide) {
        return h('span', { class: 'j_pagination_status_' }, [
          h('span', { class: '_current_' }, [currentPage.toLocaleString()]),
          ' / ',
          h('span', { class: '_total' }, [this.totalPages.toLocaleString()]),
        ])
      } else {
        return h('span', { class: 'j_pagination_status' }, [
          h('span', { class: '_current' }, [currentPage.toLocaleString()]),
          ' / ',
          h('span', { class: '_total' }, [this.totalPages.toLocaleString()]),
        ])
      }
    },
  },
  
}
